import React, { useEffect, useState } from 'react';
import './LoginStyle.css';
import LoginCarousel from './LoginCarousel';
import axios from 'axios';
const LoginSlider = ({showSlider}) => {
    const images = ["Images/login/01.webp", "Images/login/02.webp", "Images/login/03.webp", "Images/login/04.webp", "Images/login/05.webp"];
    const [imageList, setImageList] = useState([])
    const [sliderImageURL, setSliderImageURL] = useState('')

    useEffect(() => {
        if(showSlider){
            setSliderImages(setSliderImageURL, setImageList) 

        }
    }, [showSlider])
 try
{
    return (
        <LoginCarousel images={images} imageList={imageList} sliderImageURL={sliderImageURL} />
    )
}
catch(ex){ console.log('LoginSlider',ex ) ; throw new Error('LoginSlider Crashed!')}
}

export default LoginSlider
const setSliderImages = async(setSliderImageURL, setImageList) => {
       
            let imageURL = '';
            if (_PRODUCTINFO.Title === 'Logi-Sys') {
                imageURL = "https://adminportal.softlinkglobal.net/images/login/logisyserp/info.json";
            } else if (_PRODUCTINFO.Title === 'LiveImpex') {
                imageURL = "https://adminportal.softlinkglobal.net/images/login/li/info.json";
            } else if (_PRODUCTINFO.Title === 'LiveIMPEXPro') {
                imageURL = "https://adminportal.softlinkglobal.net/images/login/lsp/info.json";
            }
            setSliderImageURL(imageURL);
            const res1 = await axios.get(imageURL).then(
                (data1) => {
                        setImageList(data1.data)
                }

            ).catch((error) => { console.log('LoginSlider: ', error); });

       
}
